import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { GqlCourseCreateInput } from "~/__generated__";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import CourseForm from "../../components/CourseForm";
import useCourseCreateRoute_Create from "./api/useCourseCreateRoute_Create";

export default function CourseCreateRoute() {
    const { t } = useTranslation("course");
    const navigate = useNavigate();

    const { createCourse, error } = useCourseCreateRoute_Create();

    const handleSubmit = async (data: GqlCourseCreateInput) => {
        const result = await createCourse(data);
        const newId = result.data?.courseCreate.course.id;

        if (newId) navigate("..");
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("courseCreateScreen.title")}>
                <CourseForm onSubmit={handleSubmit} error={error} />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
